import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { addBeforeWithdrawHook } from '../store/actions';

export const useAddBeforeWithdrawHook = () => {
    const dispatch = useDispatch();

    return useCallback((callback) => {
        dispatch(addBeforeWithdrawHook(callback));
    }, [dispatch]);
};
